import authService from "./authService";
import http from "./httpService";

// const apiEndpoint = "/hedge-brown-server/api/admission-application-forms";
const apiEndpoint = "/api/admission-application-forms";

function create(data) {
  return http.post(apiEndpoint, data);
}

function update(data) {
  return http.put(apiEndpoint, data);
}

function get(id) {
  return http.get(`${apiEndpoint}/${id}`);
}
function getAll() {
  return http.get(apiEndpoint);
}

function getAllByUser() {
  const userId = authService.getCurrentUser().id;
  return http.get(`${apiEndpoint}/user/${userId}`);
}

function deleteById(id) {
  return http.delete(`${apiEndpoint}/${id}`);
}

export default {
  create,
  update,
  get,
  getAll,
  getAllByUser,
  deleteById,
};
